import { makeAutoObservable, runInAction } from "mobx";
import {
  getSummaryPatient,
} from "../Services/PatientService";
import {
  getEpisodeOfCare,
} from "../Services/EpisodeOfCareService";
import {
  getRegimen,
} from "../../Regimen/RegimenService";
import {
  getEncounter,
  createEncounter,
  editEncounter,
  deleteEncounter,
} from "../Services/EncounterService";
import {
  getListPatientRegimen
} from "../Services/PatientRegimenSevice";

import {
  confirmTransfer
} from "../Services/PatientTransferService";

import "react-toastify/dist/ReactToastify.css";
import i18n from "i18n";
import { toast } from "react-toastify";

export default class SummaryStore {
  selectedPatient = null;
  selectedEpisodeOfCare = null;
  selectedRegimen = null;
  episodeOfCareOfEncounter = null;
  listEpisodeOfCare = [];
  selectedEncounter = null;
  preCareEncounters = [];
  lastestEpisodeOfCare = null;
  lastEncounter = null;
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  keyword = "";
  loadingInitial = false;
  searchObject = null;
  encounterInitialValue = {
    id: "",
    appointmentDto: null,
    encounterDate: null,
    startDate: null,
    endDate: null,
    encounterType: null,
    indexNumber: null,
    patientRegimen: null,
    isLatestEncounter: false,
    treatmentPeriodDto: null,
    encounterCareType: null,
    encounterStage: null,
    orgEncounter: null,
    provider: null,
    patient: null,
    medicationRequests: [],
    listSymptoms: [],
    listDiagnosis: [],
    listLabTests: [],
    listImagingStudys: [],
  };
  listLabTests = [];
  selectedLabTest = null;
  listImagingStudys = [];
  selectedImagingStudy = null;
  openConfirmEncounterDelete = false;
  listMedicationItems = [];
  selectedMedicationItem = null;
  patientRegimen = null;
  listRegimenEpisodeOfCare = [];

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSelectPatient = (patient) => {
    if (
      patient &&
      patient.episodeOfCares &&
      patient.episodeOfCares.length > 0
    ) {
      patient.episodeOfCares = patient.episodeOfCares.map((e) => {
        return {
          ...e,
          registerDate: e.registerDate ? new Date(e.registerDate) : null,
        };
      });
    }
    this.selectedPatient = patient;
  };

  getSummaryPatient = async (id) => {
    this.loadingInitial = true;

    try {
      let data = await getSummaryPatient(id);
      runInAction(() => {
        //reset lại dữ liệu
        this.listEpisodeOfCare = [];
        this.preCareEncounters = [];
        this.lastestEpisodeOfCare = {};
        this.handleSelectEncounter({});
        this.handleSelectEpisodeOfCare(null);

        this.handleSelectPatient(data.data);
        if (this.selectedPatient.episodeOfCares != null) {
          this.listEpisodeOfCare = this.selectedPatient.episodeOfCares;
          this.preCareEncounters = this.selectedPatient.preCareEncounters;
          this.lastestEpisodeOfCare =
            this.listEpisodeOfCare[this.listEpisodeOfCare.length - 1];
          this.handleSelectEncounter(this.selectedPatient.lastEncounter);
        }
      });
      this.setLoadingInitial(false);
      return this.selectedPatient;
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  };

  //đợt điều trị
  handleSelectEpisodeOfCare = (episodeOfCare) => {
    this.selectedEpisodeOfCare = episodeOfCare;
    if (episodeOfCare) {
      this.getListRegimenByEpisodeOfCare(episodeOfCare.id);
    } else {
      this.handleSelectListRegimenEpisodeOfCare(null);
    }
  };

  getEpisodeOfCare = async (id) => {
    if (id != null) {
      try {
        let data = await getEpisodeOfCare(id);
        this.handleSelectEpisodeOfCare(data.data);
        return this.selectedEpisodeOfCare;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectEpisodeOfCare(null);
    }
  };

  handleSelectEpisodeOfCareForEncounter = (episodeOfCare) => {
    this.episodeOfCareOfEncounter = episodeOfCare;
  };

  getEpisodeOfCareForEncounter = async (id) => {
    if (id != null) {
      try {
        let res = await getEpisodeOfCare(id);
        this.handleSelectEpisodeOfCareForEncounter(res.data);
        return this.episodeOfCareOfEncounter;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectEpisodeOfCareForEncounter(null);
      this.listMedicationItems = [];
    }
  };

  //Thăm khám

  handleSelectEncounter = (encounter) => {
    if (encounter) {
      this.selectedEncounter = encounter;
      this.patientRegimen = encounter.patientRegimen;
      this.listLabTests = encounter.listLabTests;
      this.listImagingStudys = encounter.listImagingStudys;
      if (encounter.medicationRequests?.length > 0) {
        this.listMedicationItems = encounter.medicationRequests[0]?.medicationRequestItems
      } else {
        this.listMedicationItems = [];
      }
    } else {
      this.selectedEncounter = {...this.encounterInitialValue};
      this.listLabTests = [];
      this.listImagingStudys = [];
      this.listMedicationItems = [];
      this.selectedEpisodeOfCare = null;
      this.episodeOfCareOfEncounter = null;
    }
  };

  handleEditEncounter = (id) => {
    this.getEncounter(id).then(() => {
      // this.shouldOpenEditorDialog = true;
    });
  };

  getEncounter = async (id) => {
    if (id != null) {
      try {
        let data = await getEncounter(id);

        this.handleSelectEncounter(data.data);
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      // this.handleSelectEncounter(this.encounterInitialValue)
      this.selectedEncounter = this.encounterInitialValue;
      this.listLabTests = [];
      this.listImagingStudys = [];
      this.listMedicationItems = [];
    }
    return this.selectedEncounter;
  };

  // checkEncounter = async (encounter) => {
  //     const check = await checkEncounter(encounter);
  //     if (check.data?.code == -1) {
  //       toast.warning("Trùng ngày khám với lần khám trước!");
  //       return
  //     } 
  //     if (check.data?.medicationRequests) {
  //         this.handleSelectEncounter({
  //           ...this.selectedEncounter,
  //           medicationRequests: check.data.medicationRequests
  //         })
  //     }
  // }

  createEncounter = async (encounter) => {
    try {
      const res = await createEncounter(encounter);
      toast.success(i18n.t("toast.add_success"));
      this.handleSelectEncounter(res.data);

    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.add_fail"));
    }
  };

  editEncounter = async (encounter) => {
    try {
      const res = await editEncounter(encounter);
      toast.success(i18n.t("toast.update_success"));
      this.handleSelectEncounter(res.data);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.update_fail"));
    }
  };

  toggleConfirmEncounterDeletePopup = () => {
    this.openConfirmEncounterDelete = !this.openConfirmEncounterDelete;
  };

  handleDeleteEncounter = (id) => {
    getEncounter(id).then(() => {
      // this.openConfirmEncounterDelete = true;
      this.toggleConfirmEncounterDeletePopup();
    });
  };

  handleConfirmDeleteEncounter = () => {
    this.deleteEncounter(this.selectedEncounter.id);
  };

  deleteEncounter = async (id) => {
    try {
      await deleteEncounter(id);
      toast.success(i18n.t("toast.delete_success"));
      setTimeout(() => {
        window.location.reload();
      }, 1000)
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }
    this.toggleConfirmEncounterDeletePopup();
  };

  //phac do dieu tri

  handleSelectRegimen = (regimen) => {
    this.selectedRegimen = regimen;
  };

  handleEditRegimen = (id) => {
    this.getRegimen(id).then(() => {
      // this.shouldOpenEditorDialog = true;
    });
  };

  getRegimen = async (id) => {
    // console.log(id)
    if (id != null) {
      try {
        let res = await getRegimen(id);
        this.handleSelectRegimen(res.data);
        return this.selectedRegimen;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectRegimen(null);
    }
  };

  handleChangeRegimen = async (regimen) => {
    await this.getRegimen(regimen.id);
    this.listMedicationItems = this.selectedRegimen?.medications;
  }

  //labtest
  handleselectLabTest = (labtest) => {
    this.selectedLabTest = labtest;
  };

  handleConfirmDeleteLabTest = () => {
    this.listLabTests = this.listLabTests.filter((item) => item.tableData?.id !== this.selectedLabTest.tableData?.id)
    this.selectedLabTest = null
  }

  handleUpdateListLabTests = (labTestItem) => {
    // console.log(item);
    // console.log(this.selectedLabTest);
    //nếu selectedLabTest = null là thêm mới, không thì là cập nhật
    let list = this.listLabTests;
    if (labTestItem) {
      if (this.selectedLabTest) {
        this.listLabTests = list.map((item) => {
          if (item.tableData?.id === this.selectedLabTest.tableData?.id) {
            item = labTestItem;
          }
          return item;
        })
      } else {
        if (!list) {
          list = [];
        }
        list.push(labTestItem);
        this.listLabTests = list;
      }
    } else {
      toast.warning(i18n.t("toast.notEnterData"))
    }
    return list;
  };

  //imagingStudy
  handleSelectImagingStudy = (imagingStudy) => {
    this.selectedImagingStudy = imagingStudy;
  };

  handleConfirmDeleteImagingStudy = () => {
    this.listImagingStudys = this.listImagingStudys.filter((item) => item.tableData?.id !== this.selectedImagingStudy.tableData?.id)
    this.selectedImagingStudy = null
  }

  handleUpdateListImagingStudys = (imagingStudy) => {
    let list = this.listImagingStudys;
    if (imagingStudy) {
      if (this.selectedImagingStudy) {
        this.listImagingStudys = list.map((item) => {
          if (item.tableData?.id === this.selectedImagingStudy.tableData?.id) {
            item = imagingStudy;
          }
          return item;
        })
      } else {
        if (!list) {
          list = [];
        }
        list.push(imagingStudy);
        this.listImagingStudys = list;
      }
    } else {
      toast.warning(i18n.t("toast.notEnterData"))
    }
    return list;
  };

  //MedicationItems
  handleSelectMedicationItem = (item) => {
    this.selectedMedicationItem = item;
  };

  handleConfirmDeleteMedicationItem = () => {
    this.listMedicationItems = this.listMedicationItems.filter((item) => item.tableData?.id !== this.selectedMedicationItem.tableData?.id)
    this.selectedMedicationItem = null
  }

  handleUpdateListMedicationItems = (medicationItem) => {
    let list = this.listMedicationItems;
    if (medicationItem) {
      if (this.selectedMedicationItem) {
        //sửa
        list = list.map((item) => {
          if (item.medication.id === this.selectedMedicationItem.medication.id 
            && item.period?.id ===  this.selectedMedicationItem.period?.id) {
            item = medicationItem;
          }
          return item;
        })
      } else {
        //thêm mới
        if (!list) {
          list = [];
        }
        if (list.some((item) => item.medication.id === medicationItem.medication.id 
            && item.period?.id ===  medicationItem.period?.id)) {
              toast.warning(i18n.t("toast.alreadyExist"))
              return;
            }
        list.push(medicationItem);
      }
    } else {
      toast.warning(i18n.t("toast.notEnterData"))
    }
    this.listMedicationItems = [...list];
  };

  handleSelectListMedicationItems = (list) => {
    this.listMedicationItems = list;
  }

  handleDeleteMedicationItem = (medicationItem) => {
    let list = [];
    // debugger
    if (this.listMedicationItems?.length > 0) {
      this.listMedicationItems.forEach((item) => {
        if (item.medication?.id === medicationItem.medication?.id
          && item.period?.id === medicationItem.period?.id) {
          return
        }
        list.push(item)
      })
    }
    this.listMedicationItems = list;
  }

  handleSelectPatientRegimen = (item) => {
    this.patientRegimen = item;
  }

  //các lần thay đổi phác đồ theo đợt điều trị
  getListRegimenByEpisodeOfCare = async (periodId) => {
    if (periodId != null) {
      try {
        let res = await getListPatientRegimen({ periodId });
        this.handleSelectListRegimenEpisodeOfCare(res.data);
        return this.listRegimenEpisodeOfCare;
      } catch (error) {
        console.log(error);
        toast.warning(i18n.t("toast.error"));
      }
    } else {
      this.handleSelectListRegimenEpisodeOfCare(null);
    }
  }

  handleSelectListRegimenEpisodeOfCare = (list) => {
    this.listRegimenEpisodeOfCare = list;
  }
  confirmTransfer = async (patientTransfer) => {

    try {
      let data = await confirmTransfer(patientTransfer);
      console.log(data);
      toast.success(i18n.t("toast.successReceived"));

    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    }
  }

}
